import setPromiseState from '../../utils/promiseState';
import actionTypes from './ActionTypes';
import actionTypesAuth from '../Auth/ActionTypes';
import InitState from './InitState'

export default (state = InitState, actions) => {
  switch (actions.type) {
    case actionTypesAuth.LOGOUT.fulfilled:
      return {...InitState};
    /**
     * Create Tour
     * */
    case actionTypes.CREATE_TOUR.pending:
      return {...state, isShowPopup: true, promise: {...state.promise, createTour: {...setPromiseState(true, false, false)}}};
    case actionTypes.CREATE_TOUR.rejected:
      return {...state, isShowPopup: false, error: actions.data || {}, promise: {...state.promise, createTour: {...setPromiseState(false, false, true)}}};
    case actionTypes.CREATE_TOUR.fulfilled:
      return {...state, isShowPopup: false, error: {}, promise: {...state.promise, createTour: {...setPromiseState(false, true, false)}}};
    /**
     * Get Tour List
     * */
    case actionTypes.GET_TOUR_LIST.pending:
      return {...state, promise: {...state.promise, getTourList: {...setPromiseState(true, false, false)}}};
    case actionTypes.GET_TOUR_LIST.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, getTourList: {...setPromiseState(false, false, true)}}};
    case actionTypes.GET_TOUR_LIST.fulfilled:
      return {...state, error: {}, tourList: actions.data, promise: {...state.promise, getTourList: {...setPromiseState(false, true, false)}}};
    /**
     * Get Tour By Id
     * */
    case actionTypes.GET_TOUR_BY_ID.pending:
      return {...state, promise: {...state.promise, getTourById: {...setPromiseState(true, false, false)}}};
    case actionTypes.GET_TOUR_BY_ID.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, getTourById: {...setPromiseState(false, false, true)}}};
    case actionTypes.GET_TOUR_BY_ID.fulfilled: {
      if (actions.checkVideo) {
        return {
          ...state,
          error: {},
          tourForEdit: {...state.tourForEdit, tourVideos: actions.data.tourVideos},
          promise: {...state.promise, getTourById: {...setPromiseState(false, true, false)}}
        };
      }
      return {...state, error: {}, tourForEdit: actions.data, promise: {...state.promise, getTourById: {...setPromiseState(false, true, false)}}};
    }
    /**
     * Changed Tour Data
     * */
    case actionTypes.CHANGE_TOUR_DATA:
      return {...state, tourForEdit: {...state.tourForEdit, [actions.data.name]: actions.data.value}};
    /**
     * Tour Delete Photo
     * */
    case actionTypes.DELETE_PHOTO_TOUR.pending:
      return {...state, promise: {...state.promise, deletePhotoTour: {...setPromiseState(true, false, false)}}};
    case actionTypes.DELETE_PHOTO_TOUR.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, deletePhotoTour: {...setPromiseState(false, false, true)}}};
    case actionTypes.DELETE_PHOTO_TOUR.fulfilled:
      return {
        ...state,
        error: {},
        tourForEdit: {...state.tourForEdit, tourPhotos: actions.data},
        promise: {...state.promise, deletePhotoTour: {...setPromiseState(false, true, false)}}
      };
    /**
     * Tour Add Images
     * */
    case actionTypes.ADD_PHOTO_TOUR.pending:
      return {...state, promise: {...state.promise, addPhotoTour: {...setPromiseState(true, false, false)}}};
    case actionTypes.ADD_PHOTO_TOUR.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, addPhotoTour: {...setPromiseState(false, false, true)}}};
    case actionTypes.ADD_PHOTO_TOUR.fulfilled:
      return {
        ...state,
        error: {},
        tourForEdit: {...state.tourForEdit, tourPhotos: actions.data},
        promise: {...state.promise, addPhotoTour: {...setPromiseState(false, true, false)}}
      };
    /**
     * Upload Tour video
     * */
    case actionTypes.UPLOAD_TOUR_VIDEO.pending:
      return {...state, isShowPopup: true, promise: {...state.promise, uploadVideo: {...setPromiseState(true, false, false)}}};
    case actionTypes.UPLOAD_TOUR_VIDEO.rejected:
      return {...state, isShowPopup: false, error: actions.data || {}, promise: {...state.promise, uploadVideo: {...setPromiseState(false, false, true)}}};
    case actionTypes.UPLOAD_TOUR_VIDEO.fulfilled:
      return {...state, isShowPopup: false, error: {}, promise: {...state.promise, uploadVideo: {...setPromiseState(false, true, false)}}};
    /**
     * Toggle show popup
     * */
    case actionTypes.TOGGLE_SHOW_POPUP:
      return {...state, isShowPopup: !state.isShowPopup};

    case actionTypes.CLEAN_EDIT_TOUR_STATE:
      return {...state, tourForEdit: {}};

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Reducer.js